import {
  getDimensionFor,
  getLeftOrTop,
  getRightOrBottom,
} from "./direction-helpers"

/**
 * Develop a suggestion-based mechanism.
 * That is, ignore a checking for a specific side when we do not have a need
 * for it. Also, when we don't care about that particular side.
 *
 * TODO: implement _both_ strategy for wrapAround
 */
export const fetchWrapAroundStatusFor = (
  flexyInstance,
  elementsOnBehind,
  theSideWeAreMovingOnto = "left",
  wrapAroundMode = "container"
) => {
  const sliderContainer = flexyInstance.sliderContainer
  let relativeDelta = 0

  if (theSideWeAreMovingOnto === "left") {
    let leftmostOffset = [...sliderContainer.children].reduce(
      (leftmostEl, currentEl) => {
        let left = getLeftOrTop(
          nullifyTransforms(
            leftmostEl,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

        let currentLeft = getLeftOrTop(
          nullifyTransforms(
            currentEl,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

        return currentLeft < left ? currentEl : leftmostEl
      },
      {
        getBoundingClientRect: () => ({
          left: 100000000000,
          bottom: 100000000000,
          top: 100000000000,
          right: 100000000000,
        }),
      }
    )

    if (
      getLeftOrTop(
        nullifyTransforms(
          leftmostOffset,
          flexyInstance.options.nullifyTransformEl
        ),
        flexyInstance
      ) >
      (wrapAroundMode === "container"
        ? getLeftOrTop(
            nullifyTransforms(
              sliderContainer,
              flexyInstance.options.nullifyTransformEl
            ),
            flexyInstance
          )
        : 0)
    ) {
      relativeDelta =
        -1 *
        getDimensionFor(
          nullifyTransforms(
            sliderContainer.firstElementChild,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

      elementsOnBehind =
        elementsOnBehind === sliderContainer.children.length
          ? 1
          : elementsOnBehind + 1
    }
  }

  if (theSideWeAreMovingOnto === "right") {
    let rightmostOffset = [...sliderContainer.children].reduce(
      (rightmostEl, currentEl) => {
        let right = getRightOrBottom(
          nullifyTransforms(
            rightmostEl,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

        let currentRight = getRightOrBottom(
          nullifyTransforms(
            currentEl,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        )

        return right > currentRight ? rightmostEl : currentEl
      },
      {
        getBoundingClientRect: () => ({
          left: -1,
          bottom: -9999999999999,
          top: -1,
          right: -1,
        }),
      }
    )

    if (
      getRightOrBottom(
        nullifyTransforms(
          rightmostOffset,
          flexyInstance.options.nullifyTransformEl
        ),
        flexyInstance
      ) <
      (wrapAroundMode === "container"
        ? getRightOrBottom(
            nullifyTransforms(
              sliderContainer,
              flexyInstance.options.nullifyTransformEl
            ),
            flexyInstance
          )
        : window.innerWidth)
    ) {
      relativeDelta = getDimensionFor(
        nullifyTransforms(
          sliderContainer.firstElementChild,
          flexyInstance.options.nullifyTransformEl
        ),
        flexyInstance
      )
      elementsOnBehind =
        elementsOnBehind === 1
          ? sliderContainer.children.length
          : elementsOnBehind - 1
    }
  }

  return { relativeDelta, elementsOnBehind }
}

export function nullifyTransforms(el, elementToLookAt = null) {
  if (!el) return null
  if (el.getBoundingClientRect && !el.firstElementChild) {
    return el.getBoundingClientRect()
  }

  if (!elementToLookAt) {
    elementToLookAt = el
  }

  //add sanity checks and default values

  let { top, left, right, width, height } = el.getBoundingClientRect()

  let transformArr = window
    .getComputedStyle(elementToLookAt)
    .transform.split(/\(|,|\)/)
    .slice(1, -1)
    .map((v) => parseFloat(v))

  if (transformArr.length != 6) {
    return el.getBoundingClientRect()
  }

  // 2D matrix
  // need some math to apply inverse of matrix
  // That is the matrix of the transformation of the element
  var t = transformArr
  let det = t[0] * t[3] - t[1] * t[2]

  /*if (transformArr.length > 6)*/
  //3D matrix
  //haven't done the calculation to apply inverse of 4x4 matrix

  return {
    width: width / t[0],
    height: height / t[3],
    left: (left * t[3] - top * t[2] + t[2] * t[5] - t[4] * t[3]) / det,
    right: (right * t[3] - top * t[2] + t[2] * t[5] - t[4] * t[3]) / det,
    top: (-left * t[1] + top * t[0] + t[4] * t[1] - t[0] * t[5]) / det,
  }
}
